import axios from "axios"
import { useEffect, useState } from "react"
import "../App.css"
import { SERVER_URI } from "../utility/config"
import CarMap from "./CarMap"

function ActiveDriversAndCarsList({ dispatch, driverList, vehicleList }) {
  let userToken = localStorage.getItem("admin_token")
  const [vehicles, setVehicles] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      let driver, vehicle, listActualWorkShifts
      try {
        driver = await axios.get(`${SERVER_URI}/list_drivers/`, { headers: { Authorization: `Token ${userToken}` } })
        vehicle = await axios.get(`${SERVER_URI}/list_vehicles/`, { headers: { Authorization: `Token ${userToken}` } })
        listActualWorkShifts = await axios.get(`${SERVER_URI}/list_actual_work_shifts/`, {
          headers: { Authorization: `Token ${userToken}` },
        })
      } catch (e) {
        console.log("Error in getting drivers and cars", e)
      }

      for (var n = 0; n < driver.data.length; n++) {
        for (var z = 0; z < listActualWorkShifts.data.length; z++) {
          if (parseInt(driver.data[n].driverId) === parseInt(listActualWorkShifts.data[z].driverId) && !listActualWorkShifts.data[z].isComplete) { 
            driver.data[n].vehicleId = listActualWorkShifts.data[z].vehicleId
            for (var x = 0; x < vehicle.data.length; x++) {
              if (driver.data[n].vehicleId === Number(vehicle.data[x].vehicleId)) {
                vehicle.data[x].driverName = driver.data[n].name
                driver.data[n].registerPlate = vehicle.data[x].registerPlate
                if (driver.data[n].isDriving === true) {
                  vehicle.data[x].isDriving = true
                } else {
                  vehicle.data[x].isDriving = false
                }
                if (driver.data[n].isOnShift === true) {
                  vehicle.data[x].isOnShift = true
                } else {
                  vehicle.data[x].isOnShift = false
                }
                if (driver.data[n].isOnBreak === true) {
                  vehicle.data[x].isOnBreak = true
                } 
              else {
                  vehicle.data[x].isOnBreak = false
                }
              }
            }
          }
        }
      }
      setVehicles(vehicle.data.filter((car) => car.isOnShift === true))
      dispatch({
        type: "REFRESH_DATA",
        data: { vehicles: vehicle.data, drivers: driver.data, listActualWorkShifts: listActualWorkShifts.data },
      })
    }
    const intervalId = setInterval(() => {
      if (userToken) {
        fetchData()
      }
    }, 2000)
    return () => {
      console.log("Clearing interval")
      clearInterval(intervalId)
    }
  }, [dispatch, userToken])

  const endShift = async (driverId) => {
    try {
      await axios.delete(`${SERVER_URI}/end_shift/${driverId}`, { headers: { Authorization: `Token ${userToken}` } })
    } catch (error) {
      console.log("Error in ending shift ", error)
    }
  }

  return (
    <div className="frontPage">
      {vehicleList && <CarMap vehicles={vehicles.filter(vehicle=> vehicle.isOnShift === true)}/>}
      <div>
        <div className="frontPage_Listings">
          <h4 id="free_drivers">Vapaana olevat kuljettajat:</h4>
          {driverList
            .filter(
              (oneDriver) =>
                oneDriver.isOnShift === true && oneDriver.isDriving === false && oneDriver.isOnBreak === false
            )
            .map((driver, index) => (
              <div className="active_drivers_list" key={index} id={driver.id}>
                {driver.name}, ID: {driver.driverId}
                <br />
                Auto: {driver.registerPlate}, ID:{driver.vehicleId}
                <br/>
                <button onClick={() => endShift(driver.driverId)}>Lopeta vuoro</button>
              </div>
            ))}
          <h4 id="reserved_vehicles">Varatut/ajossa olevat autot:</h4>
          {vehicleList
            .filter(
              (onecar) =>
                (onecar.isOnShift === true && onecar.isDriving === true) ||
                (onecar.isOnShift === true && onecar.isOnBreak === true) ||
                onecar.isOnShift === false
            )
            .map((car, index) => (
              <div className="reserved_vehicle_list" key={index} id={car.id}>
                {car.registerPlate},{car.vehicleId}
              </div>
            ))}
          <h4 id="reserved_drivers">Varatut/ajossa olevat kuljettajat:</h4>
          {driverList
            .filter(
              (oneDriver) =>
                (oneDriver.isOnShift === true && oneDriver.isDriving === true) ||
                oneDriver.isOnShift === false ||
                oneDriver.isOnBreak === true
            )
            .map((driver, index) => (
              <div className="reserved_drivers_list" key={index} id={driver.id}>
                {driver.name}, {driver.driverId}
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default ActiveDriversAndCarsList
